import {useUsage} from '@hconnect/tuc-processes/fields/usage/useUsage'
import {Box, Typography} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {UsageInput} from './UsageInput'

/**
 * Third step of the RMC order stepper.
 * Allows the user to select the concrete usage for their order.
 * Redesigned to match new requirements with text input and pill buttons.
 */
export const UsageStep: React.FC = () => {
  const {t} = useTranslation()
  const {usage, setConcreteUsage, isEnabled: enabled, concreteUsageValues} = useUsage()

  // Handle usage selection from the component
  const handleUsageSelect = React.useCallback(
    async (usageValue: string) => {
      if (usageValue && usageValue.trim()) {
        setConcreteUsage(usageValue.trim())
      } else {
        setConcreteUsage(undefined)
      }
    },
    [setConcreteUsage]
  )

  // If the feature is not enabled, show a message
  if (!enabled) {
    return (
      <Box sx={{p: 2, textAlign: 'center'}}>
        <Typography variant="h6" color="text.secondary">
          {t(
            'orderIntake.rmc.orderManagement.usageNotAvailableForRegion',
            'Usage selection is not available for this region.'
          )}
        </Typography>
      </Box>
    )
  }

  return (
    <Box
      sx={{
        width: '100%',
        padding: 0
      }}
    >
      <UsageInput
        selectedUsage={usage}
        onUsageSelect={handleUsageSelect}
        availableUsages={concreteUsageValues || []}
        data-test-id="rmc-usage-input"
      />
    </Box>
  )
}
